<template>

  <div class="container">

    <div class="card">
      <section class="hero is-primary">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              Admin
            </h1>
          </div>
        </div>
      </section>
    </div>

    <div class="card">

      <b-tabs v-model="activeTab">

        <b-tab-item label="Users">
          <div
            class="button is-primary "
            @click="newUser()"
          >
            New Employee/Agent
          </div>

          <UsersList />
        </b-tab-item>

        <b-tab-item label="Dashboard">
          <EvaluationUsage />
        </b-tab-item>

      </b-tabs>

    </div>

    <b-modal
      :active.sync="$store.state.isNewUserActive"
      has-modal-card
      :canCancel="[]"
    >
      <NewUser />
    </b-modal>

  </div>

</template>

<script>
import UsersList from "@/components/admin/UsersList.vue";
import EvaluationUsage from "@/components/admin/EvaluationUsage.vue";
import NewUser from "@/components/admin/NewUser.vue";

export default {
  components: {
    UsersList,
    EvaluationUsage,
    NewUser
  },

  props: {
    open: false
  },

  data() {
    return {
      activeTab: 0
    };
  },

  methods: {
    newUser() {
      console.log("newUser()");
      this.$store.commit("SET_NEW_USER_ACTIVE", true);
    }
  }
};
</script>

<style>
</style>
